import { render, staticRenderFns } from "./generator.card.statistic.vue?vue&type=template&id=389a1d4a&"
import script from "./generator.card.statistic.vue?vue&type=script&lang=ts&"
export * from "./generator.card.statistic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports